import { init as initAmplitude } from "analytics/amplitude/amplitude";
import config from "config";
import React from "react";
import ReactDOM from "react-dom";
import Modal from "react-modal";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { initIntercom } from "vendors/intercom/initIntercom";
import App from "./App";
import "./i18n";
import store from "./redux/store";
import reportWebVitals from "./reportWebVitals";

Modal.setAppElement("#yess-root");

window.addEventListener("beforeunload", () => {
  // 새로고침 하면 항상 스크롤이 최상단에 가 있도록 한다.
  window.scrollTo(0, 0);
});

initIntercom({ appId: config.INTERCOM_APP_ID });
initAmplitude(undefined, {
  pageViewTracking: {
    trackHistoryChanges: "all",
  },
});

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("yess-root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
